import { render, staticRenderFns } from "./taskitem.vue?vue&type=template&id=1413593d&scoped=true&"
import script from "./taskitem.vue?vue&type=script&lang=js&"
export * from "./taskitem.vue?vue&type=script&lang=js&"
import style0 from "./taskitem.vue?vue&type=style&index=0&id=1413593d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1413593d",
  null
  
)

export default component.exports